import { NumericInputField } from '@buildwise/libs/forms/components/NumericInputField';
import { InputAdornment } from '@mui/material';
import { FormControl, TextField } from '@mui/material';
import { FieldLabel } from 'components/modals/addPostModal/PostDetailsForm';
import { ConfigEntryFieldType, ConfigEntryType } from 'config/config';
import { Controller, useFormContext } from 'react-hook-form';

type NumberFieldProps = {
  field: ConfigEntryType;
  showLabel?: boolean;
  showExternalLabel?: boolean;
  autoFocus?: boolean;
};

function NumberField({ field, showLabel, showExternalLabel, autoFocus }: NumberFieldProps) {
  const {
    control,
    formState: { isSubmitting },
  } = useFormContext<Record<string, any>>();

  return (
    <>
      {showExternalLabel && (
        <FieldLabel
          htmlFor={field.entryCode}
          disabled={isSubmitting}
          required={field.referenceObject?.isRequired}
        >
          {field.referenceObject?.label || field.entryDescription || field.entryCode}
        </FieldLabel>
      )}
      <Controller
        control={control}
        render={({ field: _field, fieldState }) => (
          <FormControl fullWidth>
            <TextField
              {..._field}
              autoFocus={autoFocus}
              id={field.entryCode}
              size="small"
              required={field.referenceObject?.isRequired}
              {...(field.referenceObject?.type === ConfigEntryFieldType.NUMBER && {
                InputProps: {
                  inputComponent: NumericInputField as any,
                  ...(field.referenceObject?.prefix && {
                    startAdornment: (
                      <InputAdornment position="start">
                        {field.referenceObject?.prefix}
                      </InputAdornment>
                    ),
                  }),
                  ...(field.referenceObject?.suffix && {
                    endAdornment: (
                      <InputAdornment position="end">
                        {field.referenceObject?.suffix}
                      </InputAdornment>
                    ),
                  }),
                },
              })}
              value={!!_field?.value ? _field.value : ''}
              fullWidth
              placeholder={field.referenceObject?.placeHolder}
              {...(showLabel && {
                label: field.referenceObject?.label || field.entryDescription || field.entryCode,
                inputProps: {
                  sx: {
                    padding: '4px 0',
                  },
                },
              })}
              variant="standard"
              error={!!fieldState.error}
              helperText={!!fieldState.error}
              disabled={isSubmitting}
            />
          </FormControl>
        )}
        name={field.entryCode}
      />
    </>
  );
}

export default NumberField;
